import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./parking.css";
import parking1 from "./img-domotic/parqueaderos_inteligentes.png"
import parking2 from "./img-domotic/parqueaderos_inteligentes2.png"
import parking3 from "./img-domotic/parqueaderos_inteligentes2.png"

import siemens from "./img-domotic/parqueaderos_inteligentes2.png"
import bosch from "./img-domotic/parqueaderos_inteligentes2.png"
import honeywell from "./img-domotic/parqueaderos_inteligentes2.png"
import nedap from "./img-domotic/parqueaderos_inteligentes2.png"

const IntelligentParking = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Parqueaderos Inteligentes
  const imagenesGaleria = [
    { src: parking1, alt: "Sistema de detección de vehículos", caption: "Tecnología de reconocimiento automático" },
    { src: parking2, alt: "Control de acceso vehicular", caption: "Solución integrada para flotas" },
  ];

  const servicios = [
    {
      icon: "🚗",
      titulo: "Detección Automática",
      descripcion: "Sensores IoT para identificar ocupación de espacios con precisión del 99%.",
      features: ["Tecnología LIDAR", "Cámaras ANPR", "Sensores magnéticos"]
    },
    {
      icon: "📱",
      titulo: "Reservas en Tiempo Real",
      descripcion: "Plataforma para reservar espacios mediante app móvil o web.",
      features: ["Integración con GPS", "Pago digital", "Notificaciones push"]
    },
    {
      icon: "💳",
      titulo: "Sistemas de Pago",
      descripcion: "Solución cashless con múltiples métodos de pago integrados.",
      features: ["Tarifas dinámicas", "Facturación electrónica", "Reportes fiscales"]
    },
    {
      icon: "🖥️",
      titulo: "Plataforma de Gestión",
      descripcion: "Dashboard empresarial con analítica predictiva y control remoto.",
      features: ["BI integrado", "Alertas personalizadas", "API para integraciones"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Tecnologías",
      items: [
        "Reconocimiento de placas (ANPR)",
        "Sensores ultrasónicos",
        "Sistemas LPR",
        "IoT para parking"
      ]
    },
    {
      categoria: "Software",
      items: [
        "Gestión de flotas",
        "Control de accesos",
        "Sistema de reservas",
        "Analítica de datos"
      ]
    },
    {
      categoria: "Hardware",
      items: [
        "Barreras inteligentes",
        "Pantallas de orientación",
        "Terminales de pago",
        "Centrales de control"
      ]
    }
  ];

  const marcas = [
    { nombre: "Siemens", logo: siemens },
    { nombre: "Bosch", logo: bosch },
    { nombre: "Honeywell", logo: honeywell },
    { nombre: "Nedap", logo: nedap },
    { nombre: "FLIR", logo: "/marcas/flir.png" },
    { nombre: "Parkeon", logo: "/marcas/parkeon.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.parking-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="parking-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="parking-hero">
        <div className="parking-hero-content">
          <h1 className="parking-hero-title">Parqueaderos Inteligentes</h1>
          <p className="parking-hero-subtitle">
            Soluciones automatizadas para gestión vehicular
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="parking-gallery parking-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="parking-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="parking-gallery-img"
            />
            <div className="parking-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

         {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones en Parqueaderos </h2>
    <p className="ryn-features-subtitle">Tecnología avanzada para Parqueaderos</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">Parqueaderos y Puertas Automaticas </h3>
          <ul className="ryn-feature-list">
            <li>Sistemas para  parqueaderos: barreras vehiculare,  tarjetas, stickers, captura de placas</li>
            <li>Parqueaderos inteligentes:   sistema de control de  plazas, señalización, incluye cajeros de  cobro automático y software de gestión   </li>
            <li>Sistemas para automatización de puertas corredizas y batientes</li>
          </ul>
        </div>
      </div>
      
     
    </div>
  </div>
</section>  




    </div>
  );
};

export default IntelligentParking;